module.exports = __webpack_public_path__ + "media/src/images/icons/four_squares-7f377046d79bb92c4ec70ae26cfe2797.svg";